
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@/components/scope/file-upload.vue";
import Editor from "@common/src/components/scope/editor/index.vue";
import { emptyToLine } from "@common/src/utils/common";
import CouponDiscountContent from "../components/coupon-discount-content.vue";
import QRCode from "qrcodejs2";
import t from "@common/src/i18n/t";
import { InjectFunction } from "@common/src/utils/decorator";
import ItemBlock from "@common/src/components/scope/item-block/index.vue";
import ImgLoader from "@common/src/components/scope/img-loader/index.vue";

const campaign = namespace("campaign");
const store = namespace("store");
@InjectFunction("dayjs", "permitApp")
@Component({
  components: { FileUpload, Editor, CouponDiscountContent, ItemBlock, ImgLoader }
})
export default class CollectCustomerEdit extends Vue {
  @store.State storeData;
  @campaign.Action queryCampaignDetail;
  emptyToLine = emptyToLine;
  campaignForm: any = {
    id: "111111",
    campaignName: "",
    campaignBeginTime: "",
    campaignEndTime: "",
    campaignImage: "",
    campaignDesc: "",
    isCoupon: "0",
    campaignContext: "",
    campaignImageColor: "rgb(251,132, 28)",
    prize: {
      bindCode: "",
      bindObj: {}
    },
    // 非业务直接参数
    time: [],
    bannerType: "default" // default customize
  };
  showLinkQr: boolean = false;
  get couponInfo() {
    return this.campaignForm.prize ? this.campaignForm.prize.bindObj : {};
  }
  campaignFormRules: any = {};
  get breadData() {
    return [
      { name: t("v210801.customer-accumulation-activities"), path: "/marketing/campaign/collect-customer" },
      {
        name: t("v210906.view-customer-accumulation-activities")
      }
    ];
  }
  get isAdd() {
    return this.$route.name === "marketingCardTemplateAdd";
  }
  get campaignFullUrl() {
    return `${window.H5_SITE_URL}/wx-jump?storeCode=${this.storeData.storeCode}&businessType=CAMPAIGN&campaignType=${this.campaignForm.campaignType}&campaignCode=${this.campaignForm.campaignCode}`;
  }

  mounted() {
    this.init();
  }
  get id() {
    return this.$route.params.id;
  }
  init() {
    this.queryCampaignDetail({ campaignCode: this.id }).then(data => {
      this.campaignForm = data.data;
    });
  }
  qrCode(url) {
    document.getElementById("qrcode").innerHTML = "";
    let qrcode = new QRCode("qrcode", {
      width: 120, //图像宽度
      height: 120, //图像高度
      colorDark: "#000000", //前景色
      colorLight: "#ffffff", //背景色
      typeNumber: 4,
      correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
    });
    qrcode.clear(); //清除二维码
    qrcode.makeCode(url); //生成另一个新的二维码
  }
  handleComfirmCommand(command) {
    if (command === "push") {
      this.$router.push(`/marketing/campaign/send-collect-customer/${this.campaignForm.campaignCode}`);
    } else if (command === "copyLink") {
      this.showLinkQr = true;
      setTimeout(() => {
        this.qrCode(this.campaignFullUrl);
      }, 200);
    }
  }
  handleDownloadQR() {
    const imgs = document.getElementById("qrcode").getElementsByTagName("img");
    const a = document.createElement("a");
    a.download = "QR" + new Date().getTime() || t("v210801.download-picture-name");
    a.href = imgs[0].src;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  handleEdit() {
    this.$router.push(`/marketing/campaign/collect-customer-edit/${this.id}`);
  }
}
